module.exports = __webpack_public_path__ + "5a1fe90efb8392a82a021e99a5c930c5.svg";